import { render, staticRenderFns } from "./products.pug?vue&type=template&id=66ddcb92&scoped=true&lang=pug&"
import script from "./products.ts?vue&type=script&lang=ts&"
export * from "./products.ts?vue&type=script&lang=ts&"
import style0 from "./products.scss?vue&type=style&index=0&id=66ddcb92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ddcb92",
  null
  
)

export default component.exports